/** 対象のhtml要素へスクロール */
export const smoothScrollToElement = (element: HTMLElement): void => {
  element.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

/** 対象のidへスクロール */
export const smoothScrollToId = (id: string): void => {
  const element = document.getElementById(id);
  if (!element) return;
  smoothScrollToElement(element);
};
